<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEventTypes"
        title-table="Tipo de Evento"
        module="eventTypeSettingsModule"
        sort-name="nome"
        :show-btn-add="verificarPermissao('ROLE_CORE_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_CORE_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <EventTypeForm v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import { verificarPermissao } from "@/auth/utils";
import EventTypeForm from "./form/EventTypeForm.vue";

export default {
  name: "EventTypeSetting",
  components: {
    BRow,
    BCol,
    TableComponents,
    EventTypeForm,
  },
  computed: {
    ...mapState("eventTypeSettingsModule", {
      listaEventTypes: (state) => state.listaEventTypes,
    }),
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: "id",
          field: "id",
        },
        {
          label: "Nome",
          field: "nome",
        },
        {
          label: "Ação",
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "eventTypeSettingsModule/prepareToEditEventType",
        data
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
